import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CustomModal = ({
  show,
  removeHeader,
  children,
  onClose,
  header,
  size,
  overflow,
  closeOnOutsideClick,
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // Cleanup on unmount or modal close
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !event.target.closest(".pac-item") // Check if the clicked element or its ancestors have the class "pac-item"
      ) {
        onClose();
      }
    };

    if (show && closeOnOutsideClick) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, closeOnOutsideClick, onClose]);

  if (show) {
    return (
      <>
        <div className="modal show" style={{ display: "block" }} tabIndex="-1">
          <div
            ref={modalRef}
            className={`modal-dialog modal-dialog-centered ${size === "lg" ? "modal-lg" : size === "xl" ? "modal-xl" : size === "md" ? "modal-md" : size === "sm" ? "modal-sm" : ""}`}
          >
            <div className="modal-content">
              {!removeHeader && (
                <div className="modal-header" style={{ borderBottom: "none" }}>
                  <h5 className="modal-title">{header}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={onClose}
                  ></button>
                </div>
              )}
              <div className={`modal-body ${overflow ? "" : "overflow-auto"}`}>
                {children}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    );
  } else {
    return null;
  }
};

export default CustomModal;
